<template>
    <admin-layout :sectionTitle="sectionTitle">
        <!--<nav aria-label="breadcrumb">
      <ol class="breadcrumb breadcrumb-no-gutter">
        <li class="breadcrumb-item"><a class="breadcrumb-link" href="javascript:;">Immobili</a></li>
        <li class="breadcrumb-item"><a class="breadcrumb-link" href="javascript:;">Zona attiva</a></li>
        <li class="breadcrumb-item active" aria-current="page">Scheda immobile {{ property.id }}</li>
      </ol>
    </nav>-->

        <div class="row justify-content-center agency-properties-show mt-0">
            <div class="  col-12">
                <div class="properties-profile profile-cover">
                    <div class="properties-info-container">
                        <span>{{ property.code }} - </span>
                        <span>{{ property.formatted_address }}</span>
                    </div>
                    <span class="badge-container" :class="badgeClass(property.status)">{{ findOptionLabel(statuses,
                            property.status)
                    }}</span>
                </div>

                <!-- Nav -->
                <div class="properties-nav-container">
                    <ul class="nav nav-pills mb-3" role="tablist">
                        <li class="nav-item" v-if="can.admin">
                            <a class="nav-link active" id="nav-income-statement-tab" data-toggle="pill"
                                href="#nav-income-statement" role="tab" aria-controls="nav-one-eg2"
                                aria-selected="true">Conto Economico</a>
                        </li>
                        <li class="nav-item" v-if="can.admin">
                            <a class="nav-link" id="nav-bp-tab" data-toggle="pill" href="#nav-bp" role="tab"
                                aria-controls="nav-two-eg2" aria-selected="false">Business Plan</a>
                        </li>
                        <li class="nav-item" v-if="can.admin">
                            <a class="nav-link" id="nav-info-tab" data-toggle="pill" href="#nav-info" role="tab"
                                aria-controls="nav-two-eg2" aria-selected="false">Caratteristiche</a>
                        </li>
                        <li class="nav-item" v-if="can.admin">
                            <a class="nav-link" id="nav-evaluation-tab" data-toggle="pill" href="#nav-evaluation"
                                role="tab" aria-controls="nav-one-eg2" aria-selected="true">Valutazione</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="nav-report-tab" data-toggle="pill" href="#nav-report" role="tab"
                                aria-controls="nav-two-eg2" aria-selected="false">Perizia</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="nav-data-tab" data-toggle="pill" href="#nav-data" role="tab"
                                aria-controls="nav-two-eg2" aria-selected="false">Dati</a>
                        </li>
                    </ul>
                </div>
                <!-- End Nav -->

                <!-- Tab Content -->
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="nav-income-statement" role="tabpanel"
                        aria-labelledby="nav-income-statement-tab" v-if="can.admin">
                        <income-statement></income-statement>
                    </div>

                    <div class="tab-pane fade" id="nav-bp" role="tabpanel" aria-labelledby="nav-bp-tab"
                        v-if="can.admin">
                        <business-plan></business-plan>
                    </div>

                    <div class="tab-pane fade" id="nav-info" role="tabpanel" aria-labelledby="nav-info-tab"
                        v-if="can.admin">
                        <div class="d-flex align-items-start">
                            <div class="card card-nav mr-3">
                                <div class="card-body p-0">
                                    <ul class="list-unstyled">
                                        <li data-target="#property" @click="goTo('property')"
                                            :class="{ active: isTargetSelected('property') }">
                                            <span><i class="tio-home-vs"></i> Immobile</span>
                                        </li>
                                        <li data-target="#stato-attuale" @click="goTo('stato-attuale')"
                                            :class="{ active: isTargetSelected('stato-attuale') }">
                                            <span><i class="tio-photo-gallery"></i> Foto stato attuale</span>
                                        </li>
                                        <li data-target="#documents" @click="goTo('documents')"
                                            :class="{ active: isTargetSelected('documents') }">
                                            <span><i class="tio-photo-gallery"></i> Documenti</span>
                                        </li>
                                        <li data-target="#renovation" @click="goTo('renovation')"
                                            :class="{ active: isTargetSelected('renovation') }">
                                            <span><i class="tio-photo-gallery"></i> Renovation</span>
                                        </li>
                                        <li data-target="#marketing" @click="goTo('marketing')"
                                            :class="{ active: isTargetSelected('marketing') }">
                                            <span><i class="tio-photo-gallery"></i> Marketing</span>
                                        </li>
                                        <li data-target="#user" @click="goTo('user')"
                                            :class="{ active: isTargetSelected('user') }">
                                            <span><i class="tio-user"></i> Richiedente</span>
                                        </li>
                                        <li data-target="#values" @click="goTo('values')"
                                            :class="{ active: isTargetSelected('values') }">
                                            <span><i class="tio-euro"></i> Valore</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card-nav-content flex-fill">
                                <div id="property" class="card">
                                    <div class="card-header">
                                        <h3 class="mb-0">Info immobile</h3>
                                        <strong>{{ property.code }}</strong>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Provenienza</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="text" class="form-control text-sm"
                                                        :value="property.inserted_by === 'customer' ? 'Cliente' : 'Agenzia'" />
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6">
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Tipologia</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <select v-model="property.typology" class="form-control text-sm">
                                                        <option value="" selected="">-</option>
                                                        <option v-for="(typology, i) in typologies" :key="i"
                                                            v-text="typology.label" :value="typology.value"></option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Superficie</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="number" v-model="property.surface"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Piano
                                                    appartamento</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <select v-model="property.floor_number"
                                                        class="form-control text-sm">
                                                        <option value="" selected="">-</option>
                                                        <option v-for="(floorNumber, i) in floorNumbers" :key="i"
                                                            v-text="floorNumber.label" :value="floorNumber.value">
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">N. piani edifici</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <select v-model="property.building_floors"
                                                        class="form-control text-sm">
                                                        <option value="" selected="">-</option>
                                                        <option v-for="(buildingFloor, i) in buildingFloors" :key="i"
                                                            v-text="buildingFloor.label" :value="buildingFloor.value">
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Locali</label>
                                                <div class="col-12 col-sm-7 col-lg-9 d-flex align-items-center">
                                                    <span class="form-inline-control text-sm">{{ property.rooms
                                                    }}</span>
                                                    <button type="button" @click="onDecrement('rooms')"
                                                        class="btn btn-secondary-outline">-</button>
                                                    <button type="button" @click="onIncrement('rooms')"
                                                        class="btn btn-secondary-outline">+</button>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Bagni</label>
                                                <div class="col-12 col-sm-7 col-lg-9 d-flex align-items-center">
                                                    <span class="form-inline-control text-sm">{{ property.bathrooms
                                                    }}</span>
                                                    <button type="button" @click="onDecrement('bathrooms')"
                                                        class="btn btn-secondary-outline">-</button>
                                                    <button type="button" @click="onIncrement('bathrooms')"
                                                        class="btn btn-secondary-outline">+</button>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Riscaldamento</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <select v-model="property.heating" class="form-control text-sm">
                                                        <option value="" selected="">-</option>
                                                        <option v-for="(heating, i) in heatings" :key="i"
                                                            v-text="heating.label" :value="heating.value"></option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Classe
                                                    energetica</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <select v-model="property.energetic_class"
                                                        class="form-control text-sm">
                                                        <option value="" selected="">-</option>
                                                        <option v-for="(energeticClass, i) in energeticClasses" :key="i"
                                                            v-text="energeticClass.label" :value="energeticClass.value">
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Anno di
                                                    costruzione</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="number" v-model="property.year_built"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Stato
                                                    costruzione</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <select v-model="property.property_status"
                                                        class="form-control text-sm">
                                                        <option value="" selected="">-</option>
                                                        <option v-for="(constructionStatus, i) in constructionStatuses"
                                                            :key="i" v-text="constructionStatus.label"
                                                            :value="constructionStatus.value"></option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Ascensore</label>
                                                <div class="col-12 col-sm-7 col-lg-9 d-flex align-items-center">
                                                    <div
                                                        class="flex-fill custom-control custom-control-inline custom-radio">
                                                        <input type="radio" id="withElevator"
                                                            v-model="property.elevator" :value="1"
                                                            class="custom-control-input" />
                                                        <label class="custom-control-label text-sm"
                                                            for="withElevator">Sì</label>
                                                    </div>
                                                    <div
                                                        class="flex-fill custom-control custom-control-inline custom-radio">
                                                        <input type="radio" id="withoutElevator"
                                                            v-model="property.elevator" :value="0"
                                                            class="custom-control-input" />
                                                        <label class="custom-control-label text-sm"
                                                            for="withoutElevator">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Balcone</label>
                                                <div class="col-12 col-sm-7 col-lg-9 d-flex align-items-center">
                                                    <div
                                                        class="flex-fill custom-control custom-control-inline custom-radio">
                                                        <input type="radio" id="withBalcony" v-model="property.balcony"
                                                            :value="1" class="custom-control-input" />
                                                        <label class="custom-control-label text-sm"
                                                            for="withBalcony">Sì</label>
                                                    </div>
                                                    <div
                                                        class="flex-fill custom-control custom-control-inline custom-radio">
                                                        <input type="radio" id="withoutBalcony"
                                                            v-model="property.balcony" :value="0"
                                                            class="custom-control-input" />
                                                        <label class="custom-control-label text-sm"
                                                            for="withoutBalcony">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Garage</label>
                                                <div class="col-12 col-sm-7 col-lg-9 d-flex align-items-center">
                                                    <div
                                                        class="flex-fill custom-control custom-control-inline custom-radio">
                                                        <input type="radio" id="withGarage" v-model="property.garage"
                                                            :value="1" class="custom-control-input" />
                                                        <label class="custom-control-label text-sm"
                                                            for="withGarage">Sì</label>
                                                    </div>
                                                    <div
                                                        class="flex-fill custom-control custom-control-inline custom-radio">
                                                        <input type="radio" id="withoutGarage" v-model="property.garage"
                                                            :value="0" class="custom-control-input" />
                                                        <label class="custom-control-label text-sm"
                                                            for="withoutGarage">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-6 form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Giardino</label>
                                                <div class="col-12 col-sm-7 col-lg-9 d-flex align-items-center">
                                                    <div
                                                        class="flex-fill custom-control custom-control-inline custom-radio">
                                                        <input type="radio" id="withGarden" v-model="property.garden"
                                                            :value="1" class="custom-control-input" />
                                                        <label class="custom-control-label text-sm"
                                                            for="withGarden">Sì</label>
                                                    </div>
                                                    <div
                                                        class="flex-fill custom-control custom-control-inline custom-radio">
                                                        <input type="radio" id="withoutGarden" v-model="property.garden"
                                                            :value="0" class="custom-control-input" />
                                                        <label class="custom-control-label text-sm"
                                                            for="withoutGarden">No</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group d-flex justify-content-end">
                                            <button type="button" class="btn btn-primary"
                                                @click="saveInfoData">Salva</button>
                                        </div>
                                    </div>
                                </div>

                                <div id="stato-attuale" class="card">
                                    <div class="card-header">
                                        <h3 class="mb-0">Foto stato attuale</h3>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <vue-dropzone ref="filesDropzone" id="filesDropzone"
                                                :options="dropZoneOptions" :duplicate-check="true"
                                                @vdropzone-file-added="(file) => fileAdded(file, 'files')"
                                                @vdropzone-removed-file="(file, error, xhr) => removeThisFile(file, error, xhr, 'files')">
                                            </vue-dropzone>
                                        </div>
                                    </div>

                                    <div class="form-group d-flex justify-content-start ml-4 mb-1">
                                        <small>Formati supportati: .png, .jpg, .jpeg, .pdf </small>
                                    </div>

                                    <div class="form-group d-flex justify-content-start ml-4">
                                        <small>Dimensione massima: 5MB </small>
                                    </div>

                                    <div class="form-group d-flex justify-content-end mr-3 mt-4">
                                        <button type="button" class="btn btn-primary mr-3"
                                            @click="saveImages('files')">Salva</button>
                                        <button v-if="files.length > 0" type="button" class="btn btn-primary"
                                            @click="downloadZip('files')">Scarica zip</button>
                                    </div>
                                </div>

                                <div id="documents" class="card">
                                    <div class="card-header">
                                        <h3 class="mb-0">Documenti</h3>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <vue-dropzone ref="documentsDropzone" id="documentsDropzone"
                                                :options="dropZoneOptions" :duplicate-check="true"
                                                @vdropzone-file-added="(file) => fileAdded(file, 'documents')"
                                                @vdropzone-removed-file="(file, error, xhr) => removeThisFile(file, error, xhr, 'documents')">
                                            </vue-dropzone>
                                        </div>
                                    </div>

                                    <div class="form-group d-flex justify-content-start ml-4 mb-1">
                                        <small>Formati supportati: .png, .jpg, .jpeg, .pdf, .dwg </small>
                                    </div>

                                    <div class="form-group d-flex justify-content-start ml-4">
                                        <small>Dimensione massima: 5MB </small>
                                    </div>

                                    <div class="form-group d-flex justify-content-end mr-3 mt-4">
                                        <button type="button" class="btn btn-primary mr-3"
                                            @click="saveImages('documents')">Salva</button>
                                        <button v-if="documents.length > 0" type="button" class="btn btn-primary"
                                            @click="downloadZip('documents')">Scarica zip</button>
                                    </div>
                                </div>

                                <div id="renovation" class="card">
                                    <div class="card-header">
                                        <h3 class="mb-0">Renovation</h3>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <vue-dropzone ref="renovationDropzone" id="renovationDropzone"
                                                :options="dropZoneOptions" :duplicate-check="true"
                                                @vdropzone-file-added="(file) => fileAdded(file, 'renovation')"
                                                @vdropzone-removed-file="(file, error, xhr) => removeThisFile(file, error, xhr, 'renovation')">
                                            </vue-dropzone>
                                        </div>
                                    </div>

                                    <div class="form-group d-flex justify-content-start ml-4 mb-1">
                                        <small>Formati supportati: .png, .jpg, .jpeg, .pdf, .dwg </small>
                                    </div>

                                    <div class="form-group d-flex justify-content-start ml-4">
                                        <small>Dimensione massima: 5MB </small>
                                    </div>

                                    <div class="form-group d-flex justify-content-end mr-3 mt-4">
                                        <button type="button" class="btn btn-primary mr-3"
                                            @click="saveImages('renovation')">Salva</button>
                                        <button v-if="renovation.length > 0" type="button" class="btn btn-primary"
                                            @click="downloadZip('renovation')">Scarica zip</button>
                                    </div>
                                </div>

                                <div id="marketing" class="card">
                                    <div class="card-header">
                                        <h3 class="mb-0">Marketing</h3>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <vue-dropzone ref="marketingDropzone" id="marketingDropzone"
                                                :options="dropZoneOptions" :duplicate-check="true"
                                                @vdropzone-file-added="(file) => fileAdded(file, 'marketing')"
                                                @vdropzone-removed-file="(file, error, xhr) => removeThisFile(file, error, xhr, 'marketing')">
                                            </vue-dropzone>
                                        </div>
                                    </div>

                                    <div class="form-group d-flex justify-content-start ml-4 mb-1">
                                        <small>Formati supportati: .png, .jpg, .jpeg, .pdf, .dwg </small>
                                    </div>

                                    <div class="form-group d-flex justify-content-start ml-4">
                                        <small>Dimensione massima: 5MB </small>
                                    </div>

                                    <div class="form-group d-flex justify-content-end mr-3 mt-4">
                                        <button type="button" class="btn btn-primary mr-3"
                                            @click="saveImages('marketing')">Salva</button>
                                        <button v-if="marketing.length > 0" type="button" class="btn btn-primary"
                                            @click="downloadZip('marketing')">Scarica zip</button>
                                    </div>
                                </div>

                                <div id="user" class="card">
                                    <div class="card-header">
                                        <h3 class="mb-0">Richiedente</h3>
                                    </div>
                                    <div class="card-body">
                                        <div v-if="property.agency !== null">
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Azienda</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="text" v-model="property.agency.name"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Referente</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="text" v-model="property.agency.referent_name"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Email</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="email" v-model="property.agency.referent_email"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Telefono</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="text" v-model="property.agency.referent_phone"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Nome</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="text" v-model="property.user_first_name"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Cognome</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="text" v-model="property.user_last_name"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Email</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="email" v-model="property.user_email"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Telefono</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <input type="text" v-model="property.user_phone"
                                                        class="form-control text-sm" />
                                                </div>
                                            </div>
                                            <div class="form-group row align-items-center mb-2">
                                                <label class="col-12 col-sm-5 col-lg-3 text-sm">Quando vuole essere
                                                    contattato</label>
                                                <div class="col-12 col-sm-7 col-lg-9">
                                                    <textarea class="form-control text-sm" name="contact-type"
                                                        v-model="property.message_text"
                                                        placeholder="Vorrei essere contattato dal lunedì al venerdì dopo le 18.00"
                                                        rows="3">
                          </textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group d-flex justify-content-end">
                                            <button type="button" class="btn btn-primary"
                                                @click="saveRecipientData">Salva</button>
                                        </div>
                                    </div>
                                </div>

                                <div id="values" class="card">
                                    <div class="card-header">
                                        <h3 class="mb-0">Valore immobile</h3>
                                    </div>
                                    <div v-if="property.agency !== null" class="card-body">
                                        <div class="form-group row align-items-center mb-2">
                                            <label class="col-12 col-sm-5 col-lg-3 text-sm">Richiesta
                                                proprietario</label>
                                            <div class="col-12 col-sm-7 col-lg-9">
                                                <input type="text" v-model="client_request_price"
                                                    class="form-control text-sm" />
                                            </div>
                                        </div>
                                        <div class="form-group row align-items-center mb-2">
                                            <label class="col-12 col-sm-5 col-lg-3 text-sm">Il prezzo è
                                                trattabile?</label>
                                            <div class="col-12 col-sm-7 col-lg-9">
                                                <input type="text" class="form-control text-sm"
                                                    v-model="negotiable_price" />
                                            </div>
                                        </div>
                                        <div class="form-group row align-items-center mb-2">
                                            <label class="col-12 col-sm-5 col-lg-3 text-sm">Valore immobile allo stato
                                                attuale (valutazione agenzia)</label>
                                            <div class="col-12 col-sm-7 col-lg-9">
                                                <input type="text" v-model="actual_agency_price"
                                                    class="form-control text-sm" />
                                            </div>
                                        </div>
                                        <div class="form-group row align-items-center mb-2">
                                            <label class="col-12 col-sm-5 col-lg-3 text-sm">Valore immobile
                                                ristrutturato (vautazione agenzia)</label>
                                            <div class="col-12 col-sm-7 col-lg-9">
                                                <input type="text" v-model="after_restoration_agency_price"
                                                    class="form-control text-sm" />
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="card-body">
                                        <div class="form-group row align-items-center mb-2">
                                            <label class="col-12 col-sm-5 col-lg-3 text-sm">Valore ipotizzato</label>
                                            <div class="col-12 col-sm-7 col-lg-9">
                                                <input type="text" v-model="expected_value"
                                                    class="form-control text-sm" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="nav-evaluation" role="tabpanel" aria-labelledby="nav-evaluation-tab"
                        v-if="can.admin">
                        <evaluation></evaluation>
                    </div>

                    <div class="tab-pane fade" :class="[can.admin ? '' : 'show active']" id="nav-report" role="tabpanel"
                        aria-labelledby="nav-report-tab">
                        <!-- no report -->
                        <template v-if="property.report == null">
                            <p class="text-center mt-3 mb-4">Non è stata ancora generata una perizia</p>
                            <button class="btn btn-primary d-block mx-auto" @click="addReport">Aggiungi perizia</button>
                        </template>
                        <!-- end no report -->

                        <!-- report -->
                        <template v-else>
                            <!-- <div class="d-flex align-items-start">
                <div class="card card-nav mr-3">
                  <div class="card-body p-0">
                    <ul class="list-unstyled">
                      <li v-for="(category, i) in report.categories" :key="i" :data-target="`#${category.key}`" @click="goTo(category.key)" :class="{ active: isTargetSelected(category.key) }">
                        <span><i class="tio-home-vs"></i> {{ category.name }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-nav-content flex-fill">
                  <div v-for="(category, categoryIndex) in report.categories" :key="categoryIndex" :id="category.key" class="card">
                    <div class="card-header">
                      <h3 class="mb-0">{{ category.name }}</h3>
                      <button class="btn btn-primary" @click="reportGoToCategory(category.key)">Modifica</button>
                    </div>
                    <div class="card-body">
                      <template v-for="(section, sectionIndex) in category.sections">
                        <template v-if="section.sectionType == 'single'">
                          <report-form-show :categories="report.categories" :form="section.form" :key="`section-${sectionIndex}`"></report-form-show>
                        </template>

                        <template v-else>
                          <div class="report-item p-4" v-for="(item, itemIndex) in section.items" :key="`section-${sectionIndex}-${itemIndex}`">
                            <report-form-show :categories="report.categories" :form="item"></report-form-show>
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div> -->
                            <report></report>
                        </template>
                        <!-- end report -->
                    </div>

                    <div class="tab-pane fade" id="nav-data" role="tabpanel" aria-labelledby="nav-data-tab"
                        v-if="can.admin">
                        <data-section></data-section>
                    </div>
                </div>
                <!-- End Tab Content -->
            </div>
        </div>

        <restore-data @restore-data="restoreData" />
        <add-cost @add-field="addField" :category="category" />
        <save-property @save-property="saveProperty" />
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import { Inertia } from "@inertiajs/inertia";
import vueDropzone from "vue2-dropzone";
console.log(vueDropzone);
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import FileSaver from "file-saver";
import RestoreData from "@/Pages/Admin/Properties/Restore";
import AddCost from "@/Pages/Admin/Properties/AddCost";
import SaveProperty from "@/Pages/Admin/Properties/Save";
import BusinessPlan from "./BusinessPlan/Show";
import IncomeStatement from "./IncomeStatement/Show";
import Evaluation from "./Evaluation/Show";
import Report from "./Report/Show";
import DataSection from "./DataSection/Show";
import {
    findOptionLabel,
    typology_options,
    building_floors_options,
    apt_floor_options,
    heating_options,
    conditions_options,
    status_options,
    energy_class_options
} from "../../../helpers/select-options";

export default {
    props: ["report", "can", "sectionTitle"],

    components: {
        AdminLayout,
        vueDropzone,
        JSZip,
        JSZipUtils,
        RestoreData,
        AddCost,
        SaveProperty,
        BusinessPlan,
        IncomeStatement,
        Evaluation,
        Report,
        DataSection
    },

    computed: {
        acquisto_immobile_sum() {
            return this.getCategorySum("acquisto_immobile");
        },

        costo_commerciale_sum() {
            return this.getCategorySum("costo_commerciale");
        },

        costo_renovation_sum() {
            return this.getCategorySum("costo_renovation");
        },

        oneri_finanziari_sum() {
            return this.getCategorySum("oneri_finanziari");
        },

        perSquareMetersPrice() {
            return this.after_renovation_cashouse_price !== "" ? this.addThousands(Math.round(this.formatToInt(this.after_renovation_cashouse_price) / this.property.surface)) : "";
        },

        commission() {
            return this.after_renovation_cashouse_price !== ""
                ? this.municipality_commission !== null
                    ? this.addThousands((this.formatToInt(this.after_renovation_cashouse_price) * parseInt(this.municipality_commission)) / 100)
                    : this.addThousands(Math.round((2 / 100) * this.formatToInt(this.after_renovation_cashouse_price)))
                : "";
        },

        evaluationAndAncillaryCosts() {
            let evaluationAndAncillaryCosts = this.formatToInt(this.acquisto_immobile_sum);
            return !isNaN(evaluationAndAncillaryCosts) ? evaluationAndAncillaryCosts : "";
        },

        evaluationAndCosts() {
            let evaluationAndCosts =
                this.formatToInt(this.acquisto_immobile_sum) + this.formatToInt(this.costo_commerciale_sum) + this.formatToInt(this.costo_renovation_sum) + this.formatToInt(this.oneri_finanziari_sum);
            return !isNaN(evaluationAndCosts) ? evaluationAndCosts : "";
        },

        finalProfit() {
            let finalProfit = this.formatToInt(this.after_renovation_cashouse_price) - this.formatToInt(this.evaluationAndCosts + this.formatToInt(this.reselling_agency_fee));
            return !isNaN(finalProfit) ? finalProfit : "";
        },

        roi() {
            let roi = Math.round((this.formatToInt(this.finalProfit) / (this.formatToInt(this.evaluationAndCosts) + this.formatToInt(this.reselling_agency_fee))) * 100);

            return !isNaN(roi) ? roi : "";
        },

        semaforColor() {
            let color = "";
            if (this.evaluation_value) {
                if (this.roi >= 25) {
                    color = "bg-success";
                } else if (this.roi < 25 && this.roi >= 10) {
                    color = "bg-warning";
                } else {
                    color = "bg-danger";
                }
            }

            return color;
        }
    },

    data() {
        return {
            categories: this.$page.props.categories,
            target: "property",
            property: this.$page.props.property,
            dropZoneOptions: {
                url: "/post/step/5",
                autoProcessQueue: false,
                maxFilesize: 5,
                addRemoveLinks: true,
                dictRemoveFile: "Rimuovi",
                dictDefaultMessage: "Trascina qui i tuoi file oppure scegli file",
                acceptedFiles: "image/*,application/pdf,.dwg"
            },
            targets: ["property", "marketing", "documents", "stato-attuale", "renovation", "user", "values"],
            typologies: typology_options,
            buildingFloors: building_floors_options,
            floorNumbers: apt_floor_options,
            energeticClasses: energy_class_options,
            heatings: heating_options,
            constructionStatuses: conditions_options,
            files: [],
            documents: [],
            renovation: [],
            marketing: [],
            expected_value: this.$page.props.property ? this.addThousandsData("expected_value", this.$page.props.property.expected_value) : "",
            evaluation_value: this.$page.props.property.evaluation_value ? this.addThousandsData("evaluation_value", this.$page.props.property.evaluation_value) : "",
            client_request_price: this.$page.props.property ? this.addThousandsData("client_request_price", this.$page.props.property.client_request_price) : "",
            actual_agency_price: this.$page.props.property ? this.addThousandsData("actual_agency_price", this.$page.props.property.actual_agency_price) : "",
            after_restoration_agency_price: this.$page.props.property ? this.addThousandsData("after_restoration_agency_price", this.$page.props.property.after_restoration_agency_price) : "",
            after_renovation_cashouse_price: this.$page.props.property ? this.addThousandsData("after_renovation_cashouse_price", this.$page.props.property.after_renovation_cashouse_price) : "",
            reselling_agency_fee: this.$page.props.property.reselling_agency_fee
                ? this.addThousandsData("reselling_agency_fee", this.$page.props.property.reselling_agency_fee)
                : this.after_renovation_cashouse_price !== ""
                    ? this.municipality_commission !== null
                        ? this.addThousands((this.formatToInt(this.after_renovation_cashouse_price) * parseInt(this.municipality_commission)) / 100)
                        : this.addThousands(Math.round((2 / 100) * this.formatToInt(this.after_renovation_cashouse_price)))
                    : "",
            negotiable_price: this.$page.props.property ? this.$page.props.property.negotiable_price : "",
            acquisto_immobile: this.$page.props.property.costs ? this.$page.props.property.costs.filter(cost => cost.category_id === 1) : [],
            costo_commerciale: this.$page.props.property.costs ? this.$page.props.property.costs.filter(cost => cost.category_id === 2) : [],
            costo_renovation: this.$page.props.property.costs ? this.$page.props.property.costs.filter(cost => cost.category_id === 3) : [],
            oneri_finanziari: this.$page.props.property.costs ? this.$page.props.property.costs.filter(cost => cost.category_id === 4) : [],
            category: "",
            allowed_files: ["pdf", "jpeg", "png", "jpg", "dwg"],
            statuses: status_options,
            municipality_commission: null
        };
    },

    mounted() {
        axios
            .get("/wizard/properties/" + this.property.id + "/images")
            .then(response => {
                let media = response.data;

                if (media.files && media.files.length > 0) {
                    media.files.forEach(med => {
                        let file = med;
                        let url = "/storage/" + med.id + "/" + med.file_name;
                        this.$refs.filesDropzone.manuallyAddFile(file, url);
                    });
                }

                if (media.documents && media.documents.length > 0) {
                    media.documents.forEach(med => {
                        let file = med;
                        let url = "/storage/" + med.id + "/" + med.file_name;
                        this.$refs.documentsDropzone.manuallyAddFile(file, url);
                    });
                }

                if (media.renovation && media.renovation.length > 0) {
                    media.renovation.forEach(med => {
                        let file = med;
                        let url = "/storage/" + med.id + "/" + med.file_name;
                        this.$refs.renovationDropzone.manuallyAddFile(file, url);
                    });
                }

                if (media.marketing && media.marketing.length > 0) {
                    media.marketing.forEach(med => {
                        let file = med;
                        let url = "/storage/" + med.id + "/" + med.file_name;
                        this.$refs.marketingDropzone.manuallyAddFile(file, url);
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });

        $('[data-toggle="tooltip"]').tooltip();
    },

    methods: {
        findOptionLabel,

        getCategorySum(category) {
            let total_sum = 0;

            this.$data[category].forEach(cost => {
                if (cost.amount !== null) {
                    total_sum += parseInt(cost.amount);
                } else {
                    total_sum += parseInt(cost.default_amount);
                }
            });

            if (category === "acquisto_immobile") {
                total_sum += this.formatToInt(this.evaluation_value);
            }
            return total_sum;
        },

        calcReselling() {
            if (this.reselling_agency_fee == "") {
                this.reselling_agency_fee = (this.formatToInt(this.after_renovation_cashouse_price) * 2) / 100;
            }
        },

        saveInfoData() {
            let data = {
                typology: this.property.typology,
                surface: this.property.surface,
                rooms: this.property.rooms,
                bathrooms: this.property.bathrooms,
                floor_number: this.property.floor_number,
                building_floors: this.property.building_floors,
                heating: this.property.heating,
                energetic_class: this.property.energetic_class,
                year_built: this.property.year_built,
                property_status: this.property.property_status,
                elevator: this.property.elevator,
                balcony: this.property.balcony,
                garage: this.property.garage,
                garden: this.property.garden
            };

            axios
                .put("/admin/properties/" + this.property.id, data)
                .then(response => {
                    console.log(response);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        saveRecipientData() {
            if (this.property.agency !== null) return;

            let data = {};

            if (this.property.agency === null) {
                data = {
                    user_first_name: this.property.user_first_name,
                    user_last_name: this.property.user_last_name,
                    user_email: this.property.user_email,
                    user_phone: this.property.user_phone,
                    message_text: this.property.message_text
                };
            }

            axios
                .put("/admin/properties/" + this.property.id, data)
                .then(response => {
                    console.log(response);
                })
                .catch(error => {
                    console.log(error);
                });
        },

        addThousands(value) {
            return String(value)
                .replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        addThousandsCategories(id) {
            switch (id) {
                case 1:
                    return String(this.acquisto_immobile_sum)
                        .replace(/\D/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                case 2:
                    return String(this.costo_commerciale_sum)
                        .replace(/\D/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                case 3:
                    return String(this.costo_renovation_sum)
                        .replace(/\D/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                case 4:
                    return String(this.oneri_finanziari_sum)
                        .replace(/\D/g, "")
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
        },

        addThousandsData(data, value) {
            const result = String(value)
                .replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => (this.$data[data] = result));
        },

        formatToInt(value) {
            return parseInt(String(value).replaceAll(".", ""));
        },

        fileAdded(file, collection) {
            let file_extension = file.file_name ? file.file_name.split(".") : file.name.split(".");

            if (this.allowed_files.includes(file_extension[file_extension.length - 1])) {
                this.$data[collection].push(file);
            } else {
                let dropzone = collection + "Dropzone";
                console.log(dropzone);
                console.log(this.$refs[dropzone]);
                this.$refs[dropzone].removeFile(file);
            }
        },

        removeThisFile(file, error, xhr, collection) {
            this.files = this.$data[collection].filter(filee => {
                return filee !== file;
            });
        },

        downloadZip(collection) {
            var zip = new JSZip();
            var count = 0;
            var zipFilename = "Property-" + collection + "-" + this.property.id + ".zip";

            this.$data[collection].forEach((file, i) => {
                let filename = "/storage/" + file.id + "/" + file.file_name;

                JSZipUtils.getBinaryContent(filename, (err, data) => {
                    if (err) {
                        throw err;
                    }
                    zip.file(file.file_name, data, { binary: true });
                    count++;
                    if (count == this.$data[collection].length) {
                        zip.generateAsync({ type: "blob" }).then(content => {
                            FileSaver.saveAs(content, zipFilename);
                        });
                    }
                });
            });
        },

        saveImages(collection) {
            const formData = new FormData();

            this.$data[collection].forEach(file => {
                if (file instanceof File) {
                    formData.append("media[]", file, file.name);
                } else {
                    let details = JSON.stringify(file);

                    formData.append("existing_files[]", details);
                }
            });

            formData.append("collection", collection);

            Inertia.post(route("property_images.update", this.property.id), formData, {
                preserveScroll: true,
                preserveState: true,
                onSuccess: () => {
                    this.$toast.success("Files salvati con successo")
                }
            });

            // const config = {
            //     headers: { "Content-Type": "multipart/form-data;", Accept: "application/json" }
            // };

            // axios
            //     .post(route("property_images.update", this.property.id), formData, config)
            //     .then(response => {
            //         location.reload();
            //     })
            //     .catch(error => {
            //         console.log(error);
            //     });
        },

        elementInViewport2(el) {
            var top = el.offsetTop;
            var left = el.offsetLeft;
            var width = el.offsetWidth;
            var height = el.offsetHeight;

            while (el.offsetParent) {
                el = el.offsetParent;
                top += el.offsetTop;
                left += el.offsetLeft;
            }

            return top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
        },

        goTo(target) {
            this.target = target;

            $("html,body").animate(
                {
                    scrollTop: $(`#${target}`).offset().top - 100
                },
                "slow"
            );
        },

        isTargetSelected(target) {
            return target == this.target;
        },

        onDecrement(prop) {
            if (this.property[prop] > 0) {
                this.property[prop] -= 1;
            }
        },

        onIncrement(prop) {
            this.property[prop] += 1;
        },

        dataToUpdate() {
            let data = {};

            if (this.property.agency !== null) {
                data = {
                    client_request_price: this.formatToInt(this.client_request_price),
                    negotiable_price: this.negotiable_price,
                    actual_agency_price: this.formatToInt(this.actual_agency_price),
                    after_restoration_agency_price: this.formatToInt(this.after_restoration_agency_price),
                    evaluation_value: this.formatToInt(this.evaluation_value)
                };
            } else {
                data = {
                    expected_value: this.formatToInt(this.expected_value),
                    evaluation_value: this.formatToInt(this.evaluation_value)
                };
            }

            return data;
        },

        saveProperty() {
            let costs = [];

            this.acquisto_immobile.forEach(cost => {
                costs.push({
                    property_id: this.property.id,
                    category_id: 1,
                    label: cost.label,
                    amount: cost.amount !== null ? cost.amount : cost.default_amount
                });
            });

            this.costo_commerciale.forEach(cost => {
                costs.push({
                    property_id: this.property.id,
                    category_id: 2,
                    label: cost.label,
                    amount: cost.amount !== null ? cost.amount : cost.default_amount
                });
            });

            this.costo_renovation.forEach(cost => {
                costs.push({
                    property_id: this.property.id,
                    category_id: 3,
                    label: cost.label,
                    amount: cost.amount !== null ? cost.amount : cost.default_amount
                });
            });

            this.oneri_finanziari.forEach(cost => {
                costs.push({
                    property_id: this.property.id,
                    category_id: 4,
                    label: cost.label,
                    amount: cost.amount !== null ? cost.amount : cost.default_amount
                });
            });

            const self = this;

            axios
                .put("/admin/properties/" + this.property.id, {
                    ...this.dataToUpdate(),
                    after_renovation_cashouse_price: this.formatToInt(this.after_renovation_cashouse_price),
                    reselling_agency_fee: this.formatToInt(this.reselling_agency_fee),
                    costs: costs
                })
                .then(response => {
                    self.property = response.data;
                })
                .catch(error => {
                    console.log(error);
                });

            $("#properties-save").modal("hide");

            this.$toast.success("L'immobile è stato salvato con successo");
        },

        getPropertyFromDb() {
            return axios.get("/wizard/properties/" + this.property.id).then(response => response.data);
        },

        restoreData() {
            this.getPropertyFromDb()
                .then(data => {
                    this.after_renovation_cashouse_price = data.after_renovation_cashouse_price;
                    this.evaluation_value = data.evaluation_value;
                    this.acquisto_immobile = data.costs.filter(cost => cost.category_id === 1);
                    this.costo_commerciale = data.costs.filter(cost => cost.category_id === 2);
                    this.costo_renovation = data.costs.filter(cost => cost.category_id === 3);
                    this.oneri_finanziari = data.costs.filter(cost => cost.category_id === 4);

                    if (this.property.agency !== null) {
                        this.client_request_price = data.client_request_price;
                        this.negotiable_price = data.negotiable_price;
                        this.actual_agency_price = data.actual_agency_price;
                        this.after_restoration_agency_price = data.after_restoration_agency_price;
                    } else {
                        this.expected_value = data.expected_value;
                    }

                    $("#properties-restore-data").modal("hide");
                })
                .catch(error => {
                    console.log(error);
                });

            this.$toast.success("I valori sono stati ripristinati con successo");
        },

        refreshField(field) {
            this.getPropertyFromDb().then(data => {
                this.$data[field] = data[field];
            });
        },

        refreshCostField(input, category) {
            this.getPropertyFromDb()
                .then(data => {
                    let restoring_field = this.$data[category].filter(cost => {
                        return cost.label === input.label;
                    });
                    restoring_field[0].amount = data.costs.filter(cost => cost.label === input.label)[0].amount;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        removeCostField(cost, category) {
            const index = this.$data[category].findIndex(data_cost => data_cost.label === cost.label);

            if (~index) this.$data[category].splice(index, 1);

            $(".tooltip").hide();
        },

        addField(item, category) {
            this.$data[category].push(item);

            $("#add-cost-field").modal("hide");
        },

        badgeClass(status) {
            const s = this.statuses.find(i => i.value === status);
            if (s) return s.badge;
            return "";
        },

        addReport() {
            this.$inertia.get(`/admin/properties/${this.property.id}/report`);
        }
    },

    watch: {
        client_request_price(newValue) {
            this.addThousandsData("client_request_price", newValue);
        },

        actual_agency_price(newValue) {
            this.addThousandsData("actual_agency_price", newValue);
        },

        after_restoration_agency_price(newValue) {
            this.addThousandsData("after_restoration_agency_price", newValue);
        },

        reselling_agency_fee(newValue) {
            this.addThousandsData("reselling_agency_fee", newValue);
        },

        after_renovation_cashouse_price(newValue) {
            this.addThousandsData("after_renovation_cashouse_price", newValue);
        },

        evaluation_value(newValue) {
            this.addThousandsData("evaluation_value", newValue);
        },

        expected_value(newValue) {
            this.addThousandsData("expected_value", newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
.report-item {
    background-color: var(--light);
    border-radius: 6px;
    margin-bottom: 1.5rem;
}
</style>
